/**
 * Promotion key convention (stable ids for badges.json / future DB):
 *
 *   {type}:{scope}.{section}.{element}
 *
 * - type:   bar | badge | card
 * - scope:  global | main | chatbot | learning | network | …
 * - section: sidebar | settings | header | card | …
 * - element: specific target (ai-buddy, settings, enabled, …)
 *
 * JSON `key` must match the `promotionKey` wired in code at that UI slot.
 * JSON `routes` controls when the promo is visible (page scope), not where it renders.
 * JSON `placement` controls chip position on the host (see PROMOTION_PLACEMENTS).
 *
 * @example badge:main.sidebar.ai-buddy        → main left sidebar, AI Buddy icon
 * @example badge:chatbot.sidebar.settings   → AI Buddy sub-nav “Settings”
 * @example badge:chatbot.settings.enabled   → “Enabled” control on chatbot settings page
 * @example badge:chatbot.settings.branding  → Branding card title on chatbot settings
 * @example badge:learning.course.tab.feedback → Feedback tab on course top navigation
 * @example badge:learning.course.feedback.summarize-ai → Summarize with AI on course feedback page
 * @example badge:settings.sidebar.user-properties → User properties in org settings sub-nav
 * @example badge:organisation.content.content-inspiration → Content inspiration on company news page
 */

export const PromotionKeys = {
  bar: {
    globalAiBuddyLaunch: 'bar:global.ai-buddy-launch',
    globalLaunch: 'bar:global.launch',
  },
  badge: {
    mainSidebarAiBuddy: 'badge:main.sidebar.ai-buddy',
    chatbotSidebarSettings: 'badge:chatbot.sidebar.settings',
    chatbotSettingsEnabled: 'badge:chatbot.settings.enabled',
    chatbotSettingsBranding: 'badge:chatbot.settings.branding',
    chatbotSettingsPersonality: 'badge:chatbot.settings.personality',
    chatbotSettingsAudience: 'badge:chatbot.settings.audience',
    learningCourseTabFeedback: 'badge:learning.course.tab.feedback',
    learningCourseFeedbackSummarizeAi: 'badge:learning.course.feedback.summarize-ai',
    settingsSidebarUserProperties: 'badge:settings.sidebar.user-properties',
    organisationContentContentInspiration: 'badge:organisation.content.content-inspiration',
  },
  card: {
    // card:scope.section.element — attach via <DynamicBadge promotionKey={PromotionKeys.card…} />
  },
} as const;

export type PromotionKey =
  | typeof PromotionKeys.bar[keyof typeof PromotionKeys.bar]
  | typeof PromotionKeys.badge[keyof typeof PromotionKeys.badge];
